import Cookies from 'js-cookie';

const TOKEN_KEY = 'esyprints_token';

export function getToken(): string | null {
  if (typeof window === 'undefined') return null;
  return Cookies.get(TOKEN_KEY) || null;
}

export function setToken(token: string): void {
  Cookies.set(TOKEN_KEY, token, {
    expires: 30, // 30 days
    path: '/',
    sameSite: 'lax',
    secure: import.meta.env.PROD,
  });
}

export function removeToken(): void {
  Cookies.remove(TOKEN_KEY, { path: '/' });
}

export function isAuthenticated(): boolean {
  return !!getToken();
}

// Build a /login href that round-trips back to the current page after success.
// Skips returnUrl when the user is already on an auth page (login/verify) so
// we don't loop, and never returns to the home page or external URLs.
export function buildLoginHref(currentPath: string, currentSearch = ''): string {
  if (!currentPath || currentPath === '/' || currentPath.startsWith('/login') || currentPath.startsWith('/verify') || currentPath.startsWith('/(auth)')) {
    return '/login';
  }
  const target = encodeURIComponent(currentPath + (currentSearch || ''));
  return `/login?returnUrl=${target}`;
}
